export default __webpack_public_path__ + "static/bao2-0e7b6cadd24f25d308c3fd1e232cb30f.png";